import React, { FC } from 'react';
import cn from 'classnames';

import { TStrong } from './models';

export const Strong: FC<TStrong> = ({ children, className, styles, weight = 'bold' }) => {
    return <span className={cn(styles[weight], className)}>{children}</span>;
};
